module.exports = __webpack_public_path__ + "media/img/info/cv-creator-67ece9a2d23c3d694f2129a636d38122.png";